import React from 'react';
import '../stylesheets/Payment.css';

const Payment = ({ payment, setPayment }) => {
  return (
    <>{payment &&
      <div className='Payment-win'>
        <div className='blur'></div>
        <div className='Payment-cont'>
          <div className='Payment-title-cont'>
            <h1 className='Payment-title'>Market Z</h1>
            <button className='close-btn' onClick={(event) => {
              event.preventDefault();
              setPayment(false);
            }}>
              x
            </button>
          </div>
          <div className='purchase-number-cont'>
            #3254465 de Compra
          </div>
          <div className='field-cont'>
            <div className='field-container'>
              <div className='txt-container'>
                <h2 className='field-txt'>Tipo de Documento</h2>
              </div>
              <div className='input-container'>
                <input
                  type='text'
                  className='input'
                  required
                />
              </div>
            </div>
            <div className='field-container'>
              <div className='txt-container'>
                <h2 className='field-txt'>Teléfono</h2>
              </div>
              <div className='input-container'>
                <input
                  type='text'
                  className='input'
                  required
                />
              </div>
            </div>
            <div className='field-container'>
              <div className='txt-container'>
                <h2 className='field-txt'>Valor del Pago</h2>
              </div>
              <div className='input-container'>
                <input
                  type='text'
                  className='input'
                  required
                />
              </div>
            </div>
          </div>
          <div className='Payment-btn-cont'>
            <button onClick={(event) => {
              event.preventDefault();
              setPayment(false);
            }}>
              Confimar pago
            </button>
          </div>
        </div>
      </div>
    }
    </>
  )
}

export default Payment;